import React, { useEffect } from 'react';
import { companyInfo } from '../data/mock';

const DatenschutzPage = () => {
  useEffect(() => {
    document.title = 'Datenschutzerklärung | Helper-Schweiz';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Datenschutzerklärung von Helper-Schweiz. Informationen zum Schutz Ihrer personenbezogenen Daten.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-[#f0f5fa] to-[#e8f0f8] py-16">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-[#1e3a5f]">Datenschutzerklärung</h1>
          <p className="mt-4 text-gray-600 text-lg">{companyInfo.name}</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4">
          <div className="prose prose-lg max-w-none">
            <div className="space-y-8">

              {/* Verantwortliche Stelle */}
              <div>
                <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4">1. Verantwortliche Stelle</h2>
                <div className="bg-[#f8fafc] rounded-xl p-6">
                  <p className="text-gray-600">
                    <strong>{companyInfo.name}</strong><br />
                    {companyInfo.owner}<br />
                    {companyInfo.address}<br />
                    Telefon: {companyInfo.phone}<br />
                    E-Mail: {companyInfo.email}
                  </p>
                </div>
              </div>

              {/* Allgemeine Hinweise */}
              <div>
                <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4">2. Allgemeine Hinweise</h2>
                <p className="text-gray-600 leading-relaxed">
                  Der Schutz Ihrer persönlichen Daten ist mir ein wichtiges Anliegen. Diese Datenschutzerklärung informiert Sie darüber, welche personenbezogenen Daten ich erhebe, wie ich diese verarbeite und welche Rechte Sie haben.
                </p>
                <p className="text-gray-600 leading-relaxed mt-4">
                  Die Nutzung meiner Website ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf meinen Seiten personenbezogene Daten erhoben werden, erfolgt dies stets auf freiwilliger Basis.
                </p>
              </div>

              {/* Rechtliche Grundlage */}
              <div>
                <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4">3. Rechtliche Grundlage</h2>
                <p className="text-gray-600 leading-relaxed">
                  Diese Datenschutzerklärung basiert auf dem Schweizerischen Datenschutzgesetz (DSG) sowie der Datenschutz-Grundverordnung (DSGVO) der Europäischen Union, soweit diese anwendbar ist.
                </p>
              </div>

              {/* Erhebung und Verarbeitung */}
              <div>
                <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4">4. Erhebung und Verarbeitung von Daten</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Ich erhebe und verarbeite personenbezogene Daten nur, soweit dies zur Bereitstellung meiner Dienstleistungen erforderlich ist:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2">
                  <li>Kontaktdaten (Name, E-Mail, Telefonnummer) bei Anfragen</li>
                  <li>Adressdaten für die Durchführung von Aufträgen</li>
                  <li>Technische Daten beim Besuch meiner Website (IP-Adresse, Browsertyp, Zugriffszeit)</li>
                </ul>
              </div>

              {/* Verwendungszweck */}
              <div>
                <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4">5. Verwendungszweck</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Ihre Daten werden ausschliesslich für folgende Zwecke verwendet:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2">
                  <li>Bearbeitung Ihrer Anfragen und Aufträge</li>
                  <li>Kommunikation mit Ihnen</li>
                  <li>Erstellung von Angeboten und Rechnungen</li>
                  <li>Verbesserung meiner Website und Dienstleistungen</li>
                </ul>
              </div>

              {/* Datenweitergabe */}
              <div>
                <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4">6. Weitergabe von Daten</h2>
                <p className="text-gray-600 leading-relaxed">
                  Ihre personenbezogenen Daten werden nicht an Dritte verkauft, vermietet oder weitergegeben, es sei denn:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 mt-4">
                  <li>Sie haben Ihre ausdrückliche Einwilligung erteilt</li>
                  <li>Die Weitergabe ist zur Erfüllung gesetzlicher Pflichten erforderlich</li>
                  <li>Die Weitergabe ist zur Durchsetzung meiner Rechte notwendig</li>
                </ul>
              </div>

              {/* Cookies */}
              <div>
                <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4">7. Cookies</h2>
                <p className="text-gray-600 leading-relaxed">
                  Meine Website verwendet technisch notwendige Cookies, um die Funktionalität der Website zu gewährleisten. Cookies sind kleine Textdateien, die auf Ihrem Gerät gespeichert werden. Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden.
                </p>
              </div>

              {/* Datensicherheit */}
              <div>
                <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4">8. Datensicherheit</h2>
                <p className="text-gray-600 leading-relaxed">
                  Ich setze technische und organisatorische Sicherheitsmassnahmen ein, um Ihre Daten gegen zufällige oder vorsätzliche Manipulation, Verlust, Zerstörung oder gegen den Zugriff unberechtigter Personen zu schützen. Meine Website verwendet eine SSL-Verschlüsselung für die sichere Datenübertragung.
                </p>
              </div>

              {/* Aufbewahrungsdauer */}
              <div>
                <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4">9. Aufbewahrungsdauer</h2>
                <p className="text-gray-600 leading-relaxed">
                  Ich speichere Ihre personenbezogenen Daten nur so lange, wie es für die Erfüllung der Zwecke, für die sie erhoben wurden, erforderlich ist oder wie es gesetzliche Aufbewahrungspflichten vorsehen.
                </p>
              </div>

              {/* Ihre Rechte */}
              <div>
                <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4">10. Ihre Rechte</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Sie haben folgende Rechte bezüglich Ihrer personenbezogenen Daten:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2">
                  <li><strong>Auskunftsrecht:</strong> Sie können Auskunft über Ihre gespeicherten Daten verlangen</li>
                  <li><strong>Berichtigungsrecht:</strong> Sie können die Berichtigung unrichtiger Daten verlangen</li>
                  <li><strong>Löschungsrecht:</strong> Sie können die Löschung Ihrer Daten verlangen</li>
                  <li><strong>Widerspruchsrecht:</strong> Sie können der Verarbeitung Ihrer Daten widersprechen</li>
                  <li><strong>Datenübertragbarkeit:</strong> Sie können die Herausgabe Ihrer Daten in einem gängigen Format verlangen</li>
                </ul>
              </div>

              {/* Kontakt für Datenschutz */}
              <div>
                <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4">11. Kontakt für Datenschutzanfragen</h2>
                <p className="text-gray-600 leading-relaxed">
                  Für Fragen zum Datenschutz oder zur Ausübung Ihrer Rechte können Sie mich jederzeit kontaktieren:
                </p>
                <div className="bg-[#f8fafc] rounded-xl p-6 mt-4">
                  <p className="text-gray-600">
                    E-Mail: {companyInfo.email}<br />
                    Telefon: {companyInfo.phone}
                  </p>
                </div>
              </div>

              {/* Änderungen */}
              <div>
                <h2 className="text-2xl font-bold text-[#1e3a5f] mb-4">12. Änderungen dieser Datenschutzerklärung</h2>
                <p className="text-gray-600 leading-relaxed">
                  Ich behalte mir vor, diese Datenschutzerklärung bei Bedarf anzupassen, um sie an geänderte rechtliche Anforderungen oder Änderungen meiner Dienstleistungen anzupassen. Es gilt die jeweils auf meiner Website veröffentlichte Fassung.
                </p>
              </div>

              {/* Stand */}
              <div className="pt-8 border-t">
                <p className="text-gray-500 text-sm">
                  Stand: 2026
                </p>
                <p className="text-gray-500 text-sm mt-2">
                  {companyInfo.name}<br />
                  {companyInfo.owner}<br />
                  {companyInfo.address}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DatenschutzPage;
